import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import { TeamSchedule } from './features/teamSchedule/TeamSchedule';
import { StadiumClusters } from './features/stadiumClusters/StadiumClusters';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <header className="app-header">
          <NavLink to="/">
            <img src="/logo.svg" alt="Dugout Duel logo" className="app-logo" />
          </NavLink>
          <div className="app-header-content">
            <div className="app-header-text">
              <h1 className="app-title">Dugout Duel</h1>
              <p className="app-subtitle">Your baseball scheduling tool</p>
            </div>
            <nav className="app-nav">
              <NavLink
                to="/"
                end
                className={({ isActive }) => `app-nav-link${isActive ? ' active' : ''}`}
              >
                Schedule
              </NavLink>
              <NavLink
                to="/nearby"
                className={({ isActive }) => `app-nav-link${isActive ? ' active' : ''}`}
              >
                Nearby Stadiums
              </NavLink>
            </nav>
          </div>
        </header>
        <main className="app-main">
          <Routes>
            <Route path="/" element={<TeamSchedule />} />
            <Route path="/nearby" element={<StadiumClusters />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
